import CompetencySwipeList from './CompetencySwipeList';
export default CompetencySwipeList;